/* eslint-disable react/require-default-props */
/* eslint-disable no-param-reassign */
import React, { memo } from 'react';
import Select from 'react-select';
import { Color } from 'src/theme/color';

const customStyles = ({ placeholderColor }: { placeholderColor?: string }) => {
	return {
		control: (base: any) => ({
			...base,
			height: '100%',
			minHeight: '100%',
			background: 'transparent',
			border: 'none',
			outline: 'none',
			boxShadow: 'none',
			cursor: 'pointer',
		}),
		singleValue: (base: any) => ({
			...base,
			fontWeight: '600',
			fontSize: '14px',
			color: placeholderColor || 'white',
		}),
		dropdownIndicator: (styles: any) => ({
			...styles,
			paddingTop: 0,
			paddingBottom: 0,
			color: Color.ACTION,
			paddingLeft: 0,
			paddingRight: 0,
			'&:hover': {
				color: Color.ACTION,
			},
		}),

		menu: (provided: any) => ({
			...provided,
			background: Color.BACKGROUND,
			top: '25px',
			right: 0,
			border: `1px solid ${Color.ACTION}`,
			minWidth: '100px',
			borderRadius: '5px',
		}),
		menuList: (provider: any) => ({
			...provider,
			padding: 0,
			background: Color.BACKGROUND,
			borderRadius: '4px',
		}),
		valueContainer: (provided: any) => ({
			...provided,
			padding: '0 2px',
		}),
		option: (provided: any, state: any) => ({
			...provided,
			color: state.isSelected ? Color.TEXT_SECONDARY : Color.ACTION,
			background: state.isSelected ? Color.ACTION : Color.BACKGROUND,
			'&:hover': {
				background: Color.ACTION,
				color: Color.TEXT_SECONDARY,
			},
			cursor: 'pointer',
		}),
	};
};

const SelectOverview = ({
	options,
	isDisabled,
	value,
	onChange,
	isMulti,
	onInputChange,
	inputValue,
	isSearchable,
	closeMenuOnSelect,
	menuPlacement,
	placeholder,
	isLoading,
	placeholderColor,
}: {
	options?: any;
	isDisabled?: boolean;
	value: any;
	onChange?: any;
	inputValue?: string;
	onInputChange?: (input: string) => void;
	isMulti?: boolean;
	isSearchable?: boolean;
	closeMenuOnSelect?: boolean;
	placeholder?: string;
	isLoading?: boolean;
	menuPlacement?: 'auto' | 'bottom' | 'top';
	placeholderColor?: string;
}) => {
	const onChangeInputElement = (text: string, { action }: any) => {
		if (action === 'input-change' && onInputChange) {
			onInputChange(text);
		}
	};
	return (
		<Select
			styles={customStyles({ placeholderColor })}
			placeholder={placeholder}
			isSearchable={isSearchable}
			isMulti={isMulti}
			onInputChange={onChangeInputElement}
			inputValue={inputValue}
			isLoading={isLoading}
			closeMenuOnSelect={closeMenuOnSelect}
			options={options}
			menuPlacement={menuPlacement || 'auto'}
			menuPosition="absolute"
			isDisabled={isDisabled}
			onChange={onChange}
			value={value}
			components={{
				IndicatorSeparator: () => null,
			}}
		/>
	);
};

export default memo(SelectOverview);
